import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Cursor } from "motion-plus/react";
import './App.css';
import SmoothScroll from './components/SmoothScroll';
import Home from './components/Home';
import NotFound from './components/NotFound';
import Loader from './components/Loader';

// Lazy loaded components
const Plans = React.lazy(() => import('./components/Plans'));
const Chatbot = React.lazy(() => import('./components/Chatbot'));
const Article = React.lazy(() => import('./pages/Article'));
const ArticleList = React.lazy(() => import('./pages/ArticleList'));

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const trackAssets = async () => {
      const waitForImage = (img) => {
        if (img.complete) return Promise.resolve();
        return new Promise(resolve => {
          img.onload = resolve;
          img.onerror = resolve;
          setTimeout(resolve, 2000); // reduced timeout to 2s
        });
      };

      const waitForVideo = (video) => {
        if (video.readyState >= 3) return Promise.resolve();
        return new Promise(resolve => {
          video.onloadeddata = resolve;
          video.onerror = resolve;
          setTimeout(resolve, 2000); // reduced timeout to 2s
        });
      };

      // Wait for window load first
      if (document.readyState !== 'complete') {
        await new Promise(resolve => window.addEventListener('load', resolve));
      }

      // Small delay to allow initial React components to mount
      await new Promise(resolve => setTimeout(resolve, 100));

      // Only track elements that are actually intended to load immediately
      const images = Array.from(document.querySelectorAll('img:not([loading="lazy"])'));
      const videos = Array.from(document.querySelectorAll('video:not([preload="none"])'));

      const assetPromises = [
        ...images.map(waitForImage),
        ...videos.map(waitForVideo)
      ];

      await Promise.all(assetPromises);

      // Instantly finish loading without artificial delays
      setIsLoading(false);
    };

    trackAssets();
  }, []);

  return (
    <HelmetProvider>
      <Router>
      <div className="App">
        <Loader isLoading={isLoading} />
        
        <React.Suspense fallback={null}>
          <Chatbot />
        </React.Suspense>
        
        <SmoothScroll />
        {/* Motion Plus Cursor */}
        <Cursor className="my-cursor" style={{ backgroundColor: "white" }} />
        
        <React.Suspense fallback={<Loader isLoading={true} />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/article" element={<ArticleList />} />
            <Route path="/article/:slug" element={<Article />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </React.Suspense>
      </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
